import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import { Link as RouterLink } from 'react-router-dom';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  font-weight: normal;
  margin-bottom: ${layout.spacing.small};
  padding-right: ${layout.spacing.medium};
`;

export const Image = styled.img``;

export const Link = styled(RouterLink)`
  color: ${p => p.theme.text.callToAction};
  font-weight: 600;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const Text = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${layout.spacing.xSmall};

  svg {
    margin-right: ${layout.spacing.xSmall};
    color: ${p => p.theme.icons.callToAction};
  }
`;

export const Soty = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr;
  grid-gap: ${layout.spacing.xSmall};
  margin-bottom: ${layout.spacing.large};
  margin-top: ${layout.spacing.small};

  ${Image} {
    grid-area: 1 / 1 / 3 / 2;
  }

  ${Text} {
    grid-area: 1 / 2 / 2 / 3;
  }

  ${Link} {
    grid-area: 2 / 2 / 3 / 3;
  }
`;

export const CloseButton = styled(Button)`
  width: 50%;
  margin-left: auto;
  margin-top: ${layout.spacing.small};
`;
